/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable operator-linebreak */
import React from 'react';
import { Link } from 'react-router-dom';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import TermsPopUp from '../Terms/TermsPopup';
import PrivacyPopUp from '../Terms/PrivacyPopup';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.lightThemeUnAvailable =
      window.location.pathname === '/owner-suite' ||
      window.location.pathname === '/my-fleet' ||
      window.location.pathname === '/daily-trip-analysis' ||
      window.location.pathname === '/fleet-health' ||
      window.location.pathname === '/driving-analysis' ||
      window.location.pathname === '/reports' ||
      window.location.pathname === '/settings' ||
      window.location.pathname === '/profile' ||
      window.location.pathname === '/support';
    // window.location.pathname === '/beta-access-control';

    this.state = {
      openPrivacyModal: false,
      openTermsModal: false,
    };
  }

  toggleModal = () => {
    this.setState({
      openPrivacyModal: !this.state.openPrivacyModal,
    });
  };

  openTermsModal = () => {
    this.setState({ openTermsModal: true });
  };

  closeTermsModal = () => {
    this.setState({ openTermsModal: false });
  };

  render() {
    const { openPrivacyModal, openTermsModal } = this.state;

    return (
      <>
        <footer className="footerWrapper">
          <div className="footer-left">
            <ul>
              <li
                onClick={this.toggleModal}
                className="privacyPage"
                role="presentation"
              >
                Privacy policy
              </li>
              <li
                onClick={this.openTermsModal}
                className="TersmPage"
                role="presentation"
              >
                Terms & Conditions
              </li>
              <Link to="/support">
                <li>
                  Help
                  {/* <img src={helpIcon} alt="Help" /> */}
                  <span className="ml-1">
                    <HelpOutlineIcon />
                  </span>
                </li>
              </Link>
            </ul>
          </div>
          <div className="subWrapper">
            <p className="footerList">
              For Support - Telephone: 1800-300-12345 <span>|</span>
            </p>
            <p className="footerList">
              truckonnecthelp@daimlertruck.com <span>|</span>
            </p>

            <p className="footerList">
              Copyrights © 2026 Daimler India. All rights reserved.
              {/* {`Copyrights © ${new Date().getFullYear()} Daimler India.
              All rights reserved.`} */}
            </p>
          </div>
        </footer>

        <PrivacyPopUp open={openPrivacyModal} onClose={this.toggleModal} />
        <TermsPopUp open={openTermsModal} onClose={this.closeTermsModal} />
      </>
    );
  }
}
export default Footer;
